import { io } from "socket.io-client";
import { logoutUser } from "./authService"; // Ensure this function exists

const socket = io(process.env.REACT_APP_BACKEND_URL, {
  transports: ["websocket"],
  reconnection: true,  // Enable automatic reconnection
  reconnectionAttempts: 5,  // Retry 5 times before failing
  reconnectionDelay: 1000, // Retry after 1 sec
});

// Log WebSocket status
socket.on("connect", () => {
  // console.log("Connected to WebSocket server:", socket.id);
});

socket.on("disconnect", () => {
  // console.log("Disconnected from WebSocket server.");
});

export const registerUser = (userId) => {
  if (userId) {
    // console.log(`Registering user: ${userId} with socket ${socket.id}`);
    socket.emit("registerUser", userId);
  }
};

// Handle force logout
socket.on("forceLogout", () => {
  // console.log("Received forceLogout event from server");
  alert("Your account has been disabled by the admin. Logging out...");
  logoutUser(); // Call logout function
});

export default socket;
